/* unplugin-vue-components disabled */import script from "./ConfigBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfigBtn.vue?vue&type=script&setup=true&lang=ts"

import "./ConfigBtn.vue?vue&type=style&index=0&id=5d9c73c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d9c73c6"]])

export default __exports__